module.exports = __webpack_public_path__ + "img/headshot2.8309e306.png";